import SpriteSymbol from "../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-down",
  "use": "arrow-down-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 32 32\" id=\"arrow-down\">\n<path fill=\"#444444\" d=\"M15.729 18.514l15.771-9.371v3.886l-15.771 9.371-15.771-9.371v-3.886l15.771 9.371z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol